import { logSafeErrorWithoutCustomerDataWrapper } from '@jira/polaris__lib-logging/src/logSafeErrorWithoutCustomerDataWrapper.tsx';
import { getUserProperty } from '@atlassian/jira-common-rest/src/api/latest/user-properties/index.tsx';
import FetchError from '@atlassian/jira-fetch/src/utils/errors.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED } from '../../../constants.tsx';
import type { Props, State } from '../../../types.tsx';

export const loadGlobalViewsSectionMessageDismissed =
	(): Action<State, Props> =>
	async ({ getState, setState }, { accountId }) => {
		if (!accountId) {
			return;
		}

		// User property is already loaded
		if (typeof getState().globalViews.sectionMessageDismissed === 'boolean') {
			return;
		}

		try {
			const sectionMessageDismissed = await getUserProperty<boolean>(
				accountId,
				GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED,
			);

			const state = getState();

			setState({
				...state,
				globalViews: {
					sectionMessageDismissed,
				},
			});
		} catch (error) {
			// Expected error, the property is not set yet
			if (error instanceof FetchError && error.statusCode === 404) {
				const state = getState();

				setState({
					...state,
					globalViews: {
						sectionMessageDismissed: false,
					},
				});

				return;
			}

			logSafeErrorWithoutCustomerDataWrapper(
				'polaris.onboarding.global-views.section-message',
				`Failed to get user property with key: ${GLOBAL_VIEWS_SECTION_MESSAGE_DISMISSED}`,
				error instanceof Error ? error : undefined,
			);
		}
	};
